/**
 * React environment mode
 */
export const environment = process.env.REACT_APP_MODE;
/**
 * Is production mode
 */
export const isProduction = process.env.REACT_APP_MODE === "PRODUCTION";
/**
 * Is development mode
 */
export const isDevelopment = process.env.REACT_APP_MODE === "DEVELOPMENT";
/**
 * Host URL
 */
export const host = process.env.REACT_APP_ROOT;

export const primaryColor = process.env.REACT_APP_PRIMARY_COLOR || "#BED600";
/**
 * API root URL
 */
export const apiRoot = process.env.REACT_APP_API_ROOT;
/**
 * Timeout for API requests in milliseconds
 */
export const apiTimeout = 10000;
/**
 * Wind data source. See https://github.com/waldbrandpraevention/wind-js-server
 */
export const windData = process.env.REACT_APP_WIND_DATA;
/**
 * Refetch interval in milliseconds for tiles
 */
export const refetchInterval: number = 30000;
/**
 * Local storage name for access token
 */
export const localStorageName =
  process.env.REACT_APP_LOCALSTORAGE_NAME ?? "wb_access_token";
/**
 * Enable debug mode
 */
export const enableDebug = process.env.REACT_APP_DEBUG ?? true;

export const demoMode =
  process.env.REACT_APP_DEMO_MODE === "true" ? true : false;
/**
 * Status page URL
 */
export const statusPage =
  process.env.REACT_APP_STATUS_PAGE ?? "https://status.kiwa.tech";

export const defaultMapCenter: [number, number] = process.env
  .REACT_APP_DEFAULT_MAP_CENTER
  ? JSON.parse(process.env.REACT_APP_DEFAULT_MAP_CENTER)
  : [49.8723, 8.6512];

export const organization: string =
  process.env.REACT_APP_ORGANIZATION ?? "demo";
export const organization2: string =
  process.env.REACT_APP_ORGANIZATION_2 ?? "demo";
/**
 * Default map zoom level
 */
export const defaultMapZoom: number = process.env.REACT_APP_DEFAULT_MAP_ZOOM
  ? parseInt(process.env.REACT_APP_DEFAULT_MAP_ZOOM, 10)
  : 13;

export const logoutUrl = process.env.REACT_APP_LOGOUT_URL ?? "/logout";
export const impressumUrl =
  process.env.REACT_APP_IMPRESSUM_URL ?? "https://ui.city/impressum";
export const datenschutzUrl =
  process.env.REACT_APP_DATENSCHUTZ_URL ?? "https://ui.city/datenschutz";

export const translation =
  process.env.REACT_APP_TRANSLATION === "true" ? true : false;

export const sharedState =
  process.env.REACT_APP_ENABLE_SHARED_STATE === "true" ? true : false;

export const enableDownloadPdf =
  process.env.REACT_APP_ENABLE_DOWNLOAD_PDF === "true" ? true : false;

export const commentSection =
  process.env.REACT_APP_ENABLE_COMMENT_SECTION === "true" ? true : false;

export const versionNumber = process.env.REACT_APP_VERSION_NUMBER ?? "1.0.2";

export const keycloakClientId =
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "cokcpit-react-frontend-client";
export const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM ?? "ui";
export const keycloakUrl =
  process.env.REACT_APP_KEYCLOAK_URL ??
  "https://nextcockpit.urbanpulse.de/auth/";
